import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { userService } from "../services";

const initialState = {
  /**
   * 用户信息 {id, name, sex, pic, phone}
   */
  user: null,
  /**
   * 绑定表计列表, [{meterNo, isDefault, bindingTime, meterClass, name, address, corpName}]
   */
  meters: [],
  /**
   * 当前选中表号
   */
  meterNo: null,
  isMetersLoaded: false,
  status: "idle",
  error: null
};

export const refreshMeters = createAsyncThunk("user/refreshMeters", async () => {
  const res = await userService.getMeters();
  return res.data;
});

export const refreshUser = createAsyncThunk("user/refreshUser", async () => {
  const res = await userService.getUser();
  return res.data;
});

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    clearUser: state => {
      state.user = null;
    },
    clearMeters: state => {
      state.meters = [];
      state.isMetersLoaded = false;
    },
    changeCurrentMeter: (state, action) => {
      state.meterNo = action.payload;
    }
  },
  extraReducers: {
    [refreshMeters.pending]: (state, action) => {
      state.status = "loading";
    },
    [refreshMeters.fulfilled]: (state, action) => {
      state.status = "succeeded";
      state.meters = action.payload;
      state.isMetersLoaded = true;
      // NOTE: 需要仿造 state
      state.meterNo = selectCurrentMeter({ user: state })?.meterNo;
    },
    [refreshMeters.rejected]: (state, action) => {
      state.status = "failed";
      state.error = action.error.message;
    },
    [refreshUser.pending]: (state, action) => {
      state.status = "loading";
    },
    [refreshUser.fulfilled]: (state, action) => {
      state.status = "succeeded";
      state.user = action.payload;
    },
    [refreshUser.rejected]: (state, action) => {
      state.status = "failed";
      state.error = action.error.message;
    }
  }
});

export const { clearUser, clearMeters, changeCurrentMeter } = userSlice.actions;

export const selectUser = (state) => state.user.user;
export const selectMeters = (state) => state.user.meters;
export const selectIsMetersLoaded = (state) => state.user.isMetersLoaded;
export const selectCurrentMeterNo = (state) => state.user.meterNo;
export const selectCurrentMeter = (state) => {
  if (!Array.isArray(state.user.meters)) return null;

  let curr, def, first;
  const meters = state.user.meters;

  for(let i = 0; i < meters.length; ++i) {
    const m = meters[i];
    if (i === 0) first = m;
    if (m.isDefault) def = m;
    if (m.meterNo === state.user.meterNo) {
      curr = m;
      break;
    }
  }

  return curr || def || first;
};


export default userSlice.reducer;
